<h1 >Confirm</h1>
<div>{{confirmMessage}}</div>
<div mat-dialog-actions>
  <button class="default" mat-stroked-button (click)="dialogRef.close(true)">Confirm</button>
  <button class="default" mat-stroked-button (click)="dialogRef.close(false)">Cancel</button>
</div>
